module.exports = __webpack_public_path__ + "img/image6.8bb664fb.jpeg";